import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

export default class HeroVideo extends PureComponent {
    render() {
        return (
            <div className={ style.hero } style={ this.props.style }>
                <div className={ style.heroContent } style={ this.props.contentStyle }>

                    <div className={ style.fore }>
                        <video
                        className={ style.videoPlayer }
                        autoPlay
                        muted
                        loop
                        src={ this.props.video }>
                        </video>
                    </div>
                    <div className={ style.back }>
                        { this.props.background }
                    </div>
                    <div className={ style.textWrapper }>
                        <div className={ style.text }>
                            <div className={ style.textContent }>
                                { this.props.content }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
HeroVideo.defaultProps = {
    video: '',
};
